/** Тексты из main.py: show_faq(), info_delivery(), info_faq() — plain text для Web App. */

export const ABOUT_SERVICE_PARAGRAPHS = [
  'Здесь вы можете купить Telegram Stars и Premium, а также оформить аренду NFT-подарков и номеров. Всё через официальную платформу Telegram (Fragment) — без риска для аккаунта.',
  'Оплата: пополняете баланс бота (СБП или криптовалюта), затем списывается сумма за выбранный товар. Выдача автоматическая, в среднем заказы выполняются за 15–30 секунд.',
  'В этом приложении вы также можете покупать архивные подарки Telegram — коллекционные подарки, которые отправляются получателю прямо через приложение.',
]

export const ABOUT_DELIVERY_ITEMS = [
  {
    title: 'Звёзды',
    text: 'приходят на аккаунт, указанный в заказе. Пользоваться можно сразу.',
  },
  {
    title: 'Premium',
    text: 'выдаётся на выбранный аккаунт подарком, премиум-функции доступны сразу.',
  },
  {
    title: 'Аренда NFT и номера',
    text: 'после оплаты приходит инструкция и ссылка для привязки. Срок аренды виден в «Мои подарки» / «Мои номера».',
  },
]

export const ABOUT_DELIVERY_NOTE =
  'Выдача автоматическая, заказы обрабатываются меньше чем за минуту.'

export const ABOUT_DELIVERY_WARNING =
  'При задержках (нагрузка на Telegram) — подождите до 10 минут. Не пришло — пишите в поддержку.'

export const ABOUT_FAQ_ITEMS = [
  {
    question: 'Откуда звёзды и премиум?',
    answer:
      'Покупаем через официальный Fragment. Звёзды и премиум с аккаунта не снимаются, блокировок из-за нас не бывает.',
  },
  {
    question: 'За сколько приходят звёзды и премиум?',
    answer: 'Выдача автоматическая, обычно в течение 15 секунд.',
  },
  {
    question: 'Можно покупать только себе?',
    answer: 'Нет, подарки можно отправлять любому пользователю с @username.',
  },
  {
    question: 'Могут заблокировать или забрать звёзды?',
    answer:
      'Нет. Используется официальная площадка Telegram, блокировки и снятие звёзд из-за сервиса невозможны.',
  },
]

export const ABOUT_FAQ_FOOTER =
  'Остались вопросы? Напишите в поддержку — ответим как можно быстрее.'

/** Фиксированная ссылка на политику возврата средств (не приходит с бэкенда). */
export const REFUND_POLICY_URL =
  'https://telegra.ph/Politika-vozvrata-denezhnyh-sredstv-06-08'
